import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

interface MetricCardProps {
  label: string;
  value: string;
  unit?: string;
  icon: React.ReactNode;
  iconBg: string;
  valueSuffix?: string;
  trend?: { value: number; positive: boolean };
  highlight?: 'streak' | 'xp' | 'warning' | 'success';
  large?: boolean;
  isText?: boolean;
}

export default function MetricCard({
  label,
  value,
  unit,
  icon,
  iconBg,
  trend,
  highlight,
  large,
  isText,
}: MetricCardProps) {
  const bgClass =
    highlight === 'streak' ?'bg-amber-50 border-amber-200'
      : highlight === 'xp' ?'bg-primary/5 border-primary/20'
      : highlight === 'warning' ?'bg-red-50 border-red-200'
      : highlight === 'success' ?'bg-green-50 border-green-200' :'bg-card border-border';

  return (
    <div
      className={`rounded-2xl border card-shadow p-5 flex flex-col justify-between ${bgClass} ${
        large ? 'min-h-[120px]' : 'min-h-[110px]'
      }`}
    >
      <div className="flex items-start justify-between">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${iconBg}`}>
          {icon}
        </div>
        {trend && (
          <div
            className={`flex items-center gap-1 text-xs font-600 ${
              trend.positive ? 'text-success' : 'text-danger'
            }`}
          >
            {trend.positive ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
            {Math.abs(trend.value)}%
          </div>
        )}
      </div>
      <div>
        <p className="text-xs font-500 text-muted-foreground uppercase tracking-wide mb-1">
          {label}
        </p>
        <div className="flex items-baseline gap-1.5">
          <span
            className={`font-700 font-tabular text-foreground ${
              isText ? 'text-base leading-tight' : large ? 'text-3xl' : 'text-2xl'
            }`}
          >
            {value}
          </span>
          {unit && <span className="text-sm text-muted-foreground font-500">{unit}</span>}
        </div>
      </div>
    </div>
  );
}